import { createElement } from "react";
import { RouteObject } from "react-router-dom";
import { routes } from "@shared/lib/react-router";
import { JournalSectionSix } from "./ui";

export const JournalsSectionSixRoute = (
  ...rest: RouteObject[]
): RouteObject => {
  return {
    path: `${routes.journals.section6()}`,
    element: createElement(JournalSectionSix),
    children: [...rest],
  };
};

export const JournalsSectionSixVersionRoute = (
  ...rest: RouteObject[]
): RouteObject => {
  return {
    path: `${routes.journals.journalVersionSection6()}`,
    element: createElement(JournalSectionSix),
    children: [...rest],
  };
};
